import { useState } from "react";
import "./container.css";
import "./FaqSection.css";

const FAQS = [
  {
    question: "What is a debt consolidation loan?",
    answer:
      "A debt consolidation loan combines multiple existing debts into a single loan with one EMI. This makes repayment simpler and often more manageable.",
  },
  {
    question: "Will checking my eligibility affect my credit score?",
    answer:
      "No. Checking your eligibility is a soft inquiry and does not impact your credit score. A hard inquiry may occur only if you proceed with a full loan application.",
  },
  {
    question: "How long does the approval process take?",
    answer:
      "Most applications are reviewed within 24–48 hours once all required documents are submitted. Disbursal timelines may vary based on verification and lender processing.",
  },
  {
    question: "Can I prepay or close my loan early?",
    answer:
      "Yes. You can prepay or foreclose your loan early. Applicable charges, if any, are disclosed upfront in your loan agreement and fee schedule.",
  },
];

const ChevronIcon = ({ open }: { open: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    className={`faq-chevron ${open ? "faq-chevron--open" : ""}`}
  >
    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="faq-section">
      <div className="container-8xl">
        <h2
          className="faq-heading"
          style={{ fontStyle: "normal", fontWeight: 500, fontFamily: "Inter" }}
        >
          Got Questions? We&apos;ve Got Answers
        </h2>
        <p
          className="faq-subtext"
          style={{ fontStyle: "normal", fontWeight: 400, fontFamily: "Inter" }}
        >
          Everything you need to know before getting started.
        </p>

        <div className="faq-card">
          {FAQS.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={faq.question} className="faq-item">
                <button
                  className="faq-question"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                >
                  {faq.question}
                  <ChevronIcon open={isOpen} />
                </button>

                <div className={`faq-answer ${isOpen ? "faq-answer--open" : ""}`}>
                  <div className="faq-answer-inner">
                    <p>{faq.answer}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
